import { POP_UP_WIDGET_VIEW } from "@apps/rewards/constants/popUpWidgetViews";

import type { RewardsStorefrontValuesProgramsStatusEntity } from "./models/RewardsStorefrontValuesEntities";

export const BRANDING_WIDGET_TYPES = {
    popUpWidget: "popUpWidget",
    drawerWidget: "drawerWidget",
} as const;

export const BRANDING_THEME_COLOR = {
    primaryColor: "primaryColor",
    secondaryColor: "secondaryColor",
} as const;

export const BRANDING_FONT_COLOR = {
    white: "#ffffff",
    black: "#1a1a1a",
} as const;

export const BRANDING_LAUNCHER_POSITION = {
    bottomRight: "BR",
    bottomLeft: "BL",
} as const;

export const BRANDING_LAUNCHER_STYLE = {
    iconWithText: "iconWithText",
    textOnly: "textOnly",
    iconOnly: "iconOnly",
} as const;

export const BRANDING_POPUP_VIEW = {
    home: POP_UP_WIDGET_VIEW.home,
    waysToEarnPoints: POP_UP_WIDGET_VIEW.waysToEarnPoints,
    waysToSpendPoints: POP_UP_WIDGET_VIEW.waysToSpendPoints,
    vipTiers: POP_UP_WIDGET_VIEW.vipTiers,
} as const;

export const BRANDING_LAUNCHER_ICON = {
    default: "default",
    gift: "gift",
    ticket: "ticket",
    star: "star",
    ribbon: "ribbon",
} as const;

export const BRANDING_LAUNCHER_VISIBILITY = {
    allDevices: "allDevices",
    desktopOnly: "desktopOnly",
    hide: "hide",
} as const;

export const PROGRAM_STATUS: Record<
    string,
    keyof RewardsStorefrontValuesProgramsStatusEntity
> = {
    pointsProgramEnabled: "pointsProgramEnabled",
    referralProgramEnabled: "referralProgramEnabled",
    tiersProgramEnabled: "tiersProgramEnabled",
    b2bProgramEnabled: "b2bProgramEnabled",
};
